class Helpers {
    
    /**
     * Get max value of array or object
     * @param {array, Object} arr
     * @param {String} prop
     * @return Number
     * **/
    getMax(arr, prop) {
        let max;
        
        if (typeof arr === 'object') {
            for (let i in arr) {
                if (arr.hasOwnProperty(i)) {
                    if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop])) {
                        max = arr[i];
                    }
                }
            }
        } else {
            for (let i = 0; i < arr.length; i++) {
                if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop]))
                    max = arr[i];
            }
        }
        
        return max[prop];
    }
    
    /**
     * Get min value of coordinates
     * @param {array, Object} coordinates
     * @return object
     * **/
    minFromCoordinates(coordinates) {
        
        return coordinates.reduce(function (res, obj) {
            return (obj.y < res.y) ? obj : res;
        });
    }
    
    /**
     * Get min value of array
     * @param {array} input
     * @return Number
     * **/
    min(input) {
        if (toString.call(input) !== "[object Array]")
            return false;
        return Math.min.apply(null, input);
    }
    
    /**Get sections that already drawn
     * @param {Object} sections
     * @param {Object} state
     * @return {object}
     **/
    getDrawnSectionsArray(sections, state) {
        
        if (state.length > 0) {
            let front = [];
            let left = [];
            let right = [];
            
            state.forEach((item, index) => {
                
                if (item.position === 'front' || (item.isAngle && item.position === 'frontRight')) {
                    front.push(item);
                } else if (item.position === 'frontRight') {
                    right.push(item);
                } else if (item.position === 'frontLeft') {
                    left.push(item)
                }
                
            });
            
            return {
                frontModules: front,
                leftModules: left,
                rightModules: right
            };
        } else {
            return [];
        }
    }
    
    /**Get images data (width, height, paths) from sections that already drawn
     * @param {Object} sections
     * @param {Object} state
     * @return Object
     **/
    getDrawnSectionsImagesData(sections, state) {
        let drawnSections = this.getDrawnSectionsArray(sections, state);
        
        let images = [];
        let heights = [];
        let sumWidth = 0;
        let sumHeight = 0;
        
        drawnSections.forEach(function (item) {
            sumWidth += item.img.width;
            sumHeight += item.img.height;
            heights.push(item.img.height);
            images.push(item.img);
        });
        
        return {
            maxHeight: this.getMaxOfArray(heights),
            sumWidth: sumWidth,
            sumHeight: sumHeight,
            images: images
        }
    }
    
    /**
     * Format Price - 30 000
     * @param {Number} num - number to format
     * @return String
     **/
    formattedPrice(num) {
        return String(num).replace(/^\s*(\d+)(\d{3})\s*([а-я\.]+)?\s*$/, '$1 $2 $3');
    }
    
    
    /**
     *  Get image data
     * @param {object} img - img to get data from
     * @return Object
     **/
    getImageData(img) {
        
        // Create an empty canvas element
        let canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        
        return ctx.getImageData(0, 0, canvas.width, canvas.height)
    }
    
    /**
     *  Get relative pointer position on node
     * @param node - node to watch
     * @return Object
     **/
    getRelativePointerPosition(node) {
        let transform = node.getAbsoluteTransform().copy();
        // to detect relative position we need to invert transform
        transform.invert();
        
        // get pointer (say mouse or touch) position
        let pos = node.getStage().getPointerPosition();
        
        // now we can find relative point
        return transform.point(pos);
    }
    
    /**
     *  Get max nubber in array
     * @param numArray - numbers array
     * @return Number
     **/
    getMaxOfArray(numArray) {
        return Math.max.apply(null, numArray);
    }
    
    /**
     *  Get center of line by coordinates
     * @param {object} start - start coordinates
     * @param {object} end - end coordinates
     * @return Object
     **/
    getCenterByCoordinates(start, end) {
        
        return {
            x: (start.x + end.x) / 2,
            y: (start.y + end.y) / 2,
        }
        
    }
    
    /**
     *  Get length of line by coordinates
     * @param {object} start - start coordinates
     * @param {object} end - end coordinates
     * @return Number
     **/
    getLengthByCoordinates(start, end) {
        
        return Math.sqrt(Math.pow((end.y - start.y), 2) + Math.pow((end.x - start.x), 2));
        
    }
    
    /**
     *  Get center of line by coordinates
     * @param {object} start - start coordinates
     * @param {object} end - end coordinates
     * @return Object
     **/
    getAngleByCoordinates(start, end) {
        
        return Math.atan((end.y - start.y) / (end.x - start.x)) * 180 / 3.1415
        
    }
    
    /**
     * Get start coordinates
     * @param {object} state
     * @param {object} sections
     * @return {object}
     **/
    getStartPoint(state, sections) {
        let shiftY = 0;
        let shiftX = 0;
        
        let angleLeft = {
            exists: false,
            prepend: false
        };
        
        state.forEach((item, index) => {
            
            if (item['isAngle'] === true && (item['position'] === 'front')) {
                angleLeft = {
                    exists: true,
                    prepend: item['prepends']
                }
            }
            
            if (item.prepends === true && state.length > 1) {
                if (item.position === 'frontLeft') {
                    shiftY -= (sections[item.id]['image']['frontLeft']['prepend']['sizeY']);
                    shiftX -= (sections[item.id]['image']['frontLeft']['prepend']['sizeX']);
                }
                
                if (item.position === 'back') {
                    shiftY += (sections[item.id]['image']['back']['prepend']['sizeY']);
                    shiftX += (sections[item.id]['image']['back']['prepend']['sizeX']);
                }
                
                if (item.position === 'frontRight') {
                    shiftY += (sections[item.id]['image']['frontRight']['prepend']['sizeY']);
                    shiftX += (sections[item.id]['image']['frontRight']['prepend']['sizeX']);
                }
                
                if (item.position === 'front') {
                    shiftY -= (sections[item.id]['image']['front']['prepend']['sizeY']);
                    shiftX -= (sections[item.id]['image']['front']['prepend']['sizeX']);
                }
            }
        });
        
        return {x: shiftX, y: shiftY};
        
        /*        let first = state[0];
                let imageItem = sections[first.id]['image'];
    
                console.log('first', first);
                console.log('sections[first.id]', sections[first.id]);
    
                let firstOffset = {
                    x: sections[first.id].offsetX,
                    y: sections[first.id].offsetY
                };
                let firstSize = {
                    x: sections[first.id].sizeX,
                    y: sections[first.id].sizeY
                };
    
                let firstX = 0;
                let firstY = 0;
    
                return {x: first.x, y: first.y};*/
    }
    
    
    /**
     * Get angle items from state
     * @param {object} state
     * @return {object}
     * */
    getAnglesFromState(state) {
        let res = {};
        let lockFrontLeft = false;
        let lockFrontRight = false;
        
        state.forEach(function (item, index) {
            
            if (item.position === 'front') {
                if (!lockFrontLeft) {
                    res.frontLeftAngle = item;
                    lockFrontLeft = true;
                }
            } else if (item.position === 'frontRight') {
                if (!lockFrontRight) {
                    res.frontRightAngle = item;
                    lockFrontRight = true;
                }
            }
        });
        
        if (!lockFrontRight) {
            res.frontRightAngle = state[state.length - 1];
        }
        
        return res;
    }
    
    
    /**
     * Scale interface
     * @param {ConfiguratorSofa} object
     * @param {ConfiguratorPerson} person
     */
    scaleFromState(object, person) {
        
        let container = object.canvas;
        let containerWidth = container.width();
        let containerHeight = container.height();
        let currentScale = object.group.scaleX();
        let imageSize = (object.imageSize * object.scale) * object.configurator.fullScale;
        
        let arrX = [];
        let arrY = [];
        
        object.state.forEach(function (item, index) {
            
            let x = item.x + object.group.x();
            let y = item.y + object.group.y();
            
            arrX.push(x * object.configurator.fullScale);
            arrY.push(y * object.configurator.fullScale);
            
        });
        
        let minX = Math.min.apply(null, arrX);
        let maxX = Math.max.apply(null, arrX);
        let minY = Math.min.apply(null, arrY);
        let maxY = Math.max.apply(null, arrY);
        
        let possibleOverflows = [-minX, (maxX + imageSize) - containerWidth, -minY, (maxY + imageSize) - containerHeight];
        let maxOverflow = Math.max.apply(null, possibleOverflows);
        
        /*if overflow left*/
        
        //console.log('possibleOverflows', possibleOverflows);
        //console.log('maxOverflow', maxOverflow);
        
        if (maxOverflow > 50 * object.configurator.fullScale) {
            let scale = 0.9 - maxOverflow / 1000 * object.configurator.fullScale;
            
            let groupX = object.groupX;
            let groupY = object.groupY;
            let personX = person.group.x();
            let personY = person.group.y();
            
            console.log('scale', scale)
            
            if (scale >= 0.4) {
                object.group.scaleX(scale);
                object.group.scaleY(scale);
                object.group.x(groupX + ((1 - scale) * 100));
                object.group.y(groupY + ((1 - scale) * 100));
                
                person.group.scaleX(scale);
                person.group.scaleY(scale);
                person.group.x(personX / scale);
                person.group.y(personY / scale);
                /*
                person.group.x(person.position.x / 2.5 + ((1 - scale) * 100));
                person.group.y(person.position.y / 2.5 + ((1 - scale) * 100));*/
            } else {
                object.group.scaleX(0.4);
                object.group.scaleY(0.4);
                object.group.x(groupX + 60);
                object.group.y(groupY + 60);
                
                person.group.scaleX(0.4);
                person.group.scaleY(0.4);
                person.group.x(0);
                person.group.y(0);
            }
            
            console.log('object.group.position on scale', object.group.position())
        } else {
            let groupX = object.groupX;
            let groupY = object.groupY;
            
            object.group.scaleX(1);
            object.group.scaleY(1);
            object.group.x(groupX);
            object.group.y(groupY);
            
            person.group.scaleX(1);
            person.group.scaleY(1);
            person.group.x(0);
            person.group.y(0);
        }
        
        //console.log('object.group.scale', object.group.scaleX(), object.group.scaleY());
    }
    
    /**
     * Execute callback if file exists
     * @param {String} src
     * @param {function} callback
     **/
    executeIfFileExist(src, callback) {
        
        $.ajax({
            url: src,
            type: 'HEAD',
            error: function () {
                console.log('file not exists!!!');
            },
            success: function () {
                callback()
            }
        });
    }
    
    /**
     * Get scaled dots from center, coefficient and points
     * */
    getScaledDots(k, points) {
        
        return points.map((point) => {
            
            point[0] = point[0] * k;
            point[1] = point[1] * k;
            
            return point;
        });
    }
    
    /**
     * Get parameter from url
     * */
    findGetParameter(parameterName) {
        let result = null,
          tmp = [];
        location.search
          .substr(1)
          .split("&")
          .forEach(function (item) {
              tmp = item.split("=");
              if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
          });
        return result;
    }
    
    /**
     * Set offsets to admin automatically;
     * */
    setOffsetsToAdmin(newX, newY, item, sofa) {
        
        let object = this;
        
        let moduleId = item.info.moduleId;
        let position = item.info.position;
        let queuePosition = item.info.queuePosition;
        let sofaId = sofa.sofaId;
        
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'offsetX': newX,
                'offsetY': newY,
                'moduleId': moduleId,
                'position': position,
                'queuePosition': queuePosition,
                'sofaId': sofaId,
                'action': 'set_module_offsets',
            },
            beforeSend: () => {
                console.log('set_module_offsets');
            },
            success: (response) => {
                alert('saved!');
                console.log(response);
            },
            error: function (jqXHR, exception) {
                object.jqXHRMessage(jqXHR, exception)
            },
            complete: function () {
            }
        });
    }
    
    /**
     * Set coordinates to admin automatically;
     * */
    setCoordinatesToAdmin(item, sofa) {
        let object = this;
        
        let moduleId = item.info.moduleId;
        let position = item.info.position;
        let queuePosition = item.info.queuePosition;
        let sofaId = sofa.sofaId;
        
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'coordinates': item.coordinates,
                'moduleId': moduleId,
                'position': position,
                'queuePosition': queuePosition,
                'sofaId': sofaId,
                'action': 'set_module_coordinates',
            },
            beforeSend: () => {
                console.log('set_module_offsets');
            },
            success: (response) => {
                console.log(response);
            },
            error: function (jqXHR, exception) {
                object.jqXHRMessage(jqXHR, exception)
            },
            complete: function () {
            }
        });
    }
    
    /**
     * Set sizes to admin automatically;
     * */
    setSizesToAdmin(sizeX, sizeY, item, sofa) {
        
        let object = this;
        let moduleId = item.info.moduleId;
        let position = item.info.position;
        let queuePosition = item.info.queuePosition;
        let sofaId = sofa.sofaId;
        
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'sizeX': sizeX,
                'sizeY': sizeY,
                'moduleId': moduleId,
                'position': position,
                'queuePosition': queuePosition,
                'sofaId': sofaId,
                'action': 'set_module_sizes',
            },
            beforeSend: () => {
                console.log('set_module_sizes');
            },
            success: (response) => {
                alert('saved!');
                console.log(response);
            },
            error: function (jqXHR, exception) {
                object.jqXHRMessage(jqXHR, exception)
            },
            complete: function () {
            }
        });
    }
    
    /**
     * Set shifts to admin automatically;
     * */
    setShiftsToAdmin(shiftX, shiftY, item, sofa) {
        
        let object = this;
        let moduleId = item.info.moduleId;
        let position = item.info.position;
        let queuePosition = item.info.queuePosition;
        let sofaId = sofa.sofaId;
        
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'shiftX': shiftX,
                'shiftY': shiftY,
                'moduleId': moduleId,
                'position': position,
                'queuePosition': queuePosition,
                'sofaId': sofaId,
                'action': 'set_module_shifts',
            },
            beforeSend: () => {
                console.log('set_module_shifts');
            },
            success: (response) => {
                alert('saved!');
                console.log(response);
            },
            error: function (jqXHR, exception) {
                object.jqXHRMessage(jqXHR, exception)
            },
            complete: function () {
            }
        });
    }
    
    
    /**
     * Handle error output function
     * */
    jqXHRMessage(jqXHR, exception) {
        let msg = '';
        if (jqXHR.status === 0) {
            msg = 'Not connect.\n Verify Network.';
        } else if (jqXHR.status == 404) {
            msg = 'Requested page not found. [404]';
        } else if (jqXHR.status == 500) {
            msg = 'Internal Server Error [500].';
        } else if (exception === 'parsererror') {
            msg = 'Requested JSON parse failed.';
        } else if (exception === 'timeout') {
            msg = 'Time out error.';
        } else if (exception === 'abort') {
            msg = 'Ajax request aborted.';
        } else {
            msg = 'Uncaught Error.\n' + jqXHR.responseText;
        }
        console.log(msg);
    }
    
    /**
     * Process position of chair depends on current angles
     * */
    processChairPosition(item, object, remove = false) {
        
        if (object.chair.exists) {
            let chairs = [];
            
            object.state.forEach((item, index) => {
                if (item.isChair) {
                    chairs.push(item);
                }
            });
            
            chairs.forEach((chair, index) => {
                if (!remove) {
                    
                    if (item.isAngle && (item.prepends === chair.prepends)) {
                        
                        // console.log('item.isAngle && (item.prepends === chair.prepends)');
                        // console.log('item.position',item.position);
                        // console.log('chair.position',chair.position);
                        
                        if (item.prepends) {
                            if (item.position === 'frontRight') {
                                chair.position = 'frontRight'
                            }
                            
                            if (item.position === 'frontLeft') {
                                chair.position = 'back'
                            }
                            
                            if (item.position === 'front') {
                                chair.position = 'front'
                            }
                            
                            if (item.position === 'back') {
                                chair.position = 'frontRight'
                            }
                        } else {
                            if (item.position === 'frontRight') {
                                chair.position = 'frontRight'
                            }
                            
                            if (item.position === 'frontLeft') {
                                chair.position = 'back'
                            }
                            
                            if (item.position === 'front') {
                                chair.position = 'front'
                            }
                            
                            if (item.position === 'back') {
                                chair.position = 'back'
                            }
                        }
                        
                    }
                } else {
                    // console.log('lets remove it!');
                    
                    if (item.isAngle && (item.prepends === chair.prepends)) {
                        
                        // console.log('item.isAngle && (item.prepends === chair.prepends)');
                        // console.log('item.position',item.position);
                        // console.log('chair.position',chair.position);
                        
                        if (item.position === 'frontRight') {
                            chair.position = 'front'
                        }
                        
                        if (item.position === 'frontLeft') {
                            chair.position = 'frontLeft'
                        }
                        
                        if (item.position === 'front') {
                            chair.position = 'frontRight'
                        }
                        
                        if (item.position === 'back') {
                            chair.position = 'frontRight'
                        }
                    }
                }
            })
        }
    }
    
    /*detectTooCloseModules (object) {
        let closesLines = [];
  
        if(object.frontCount < 2) {
  
        }
        if(object.frontLeftCount < 2) {
  
        }
        if(object.frontRightCount < 3) {
  
        }
    }*/
    
    /**
     * @param {ConfiguratorPerson} person
     * @param {ConfiguratorSofa} sofa
     */
    getPersonPositionBySofas(person, sofa) {
        const state = sofa.state;
        
        if (state.length > 0) {
            let firstAngle = undefined;
            
            const sides = {
                front: [],
                left: [],
                right: [],
                back: [],
            };
            
            state.forEach((item) => {
                if (item.position === 'front') {
                    sides.front.push(item);
                } else if (item.position === 'frontRight') {
                    sides.right.push(item);
                } else if (item.position === 'frontLeft') {
                    sides.left.push(item)
                } else if (item.position === 'back') {
                    sides.back.push(item);
                }
                
                if (!firstAngle && item.isAngle && item.position === 'frontLeft') {
                    firstAngle = item;
                }
            });
            
            const offset = person.imageSize / 1.4 * person.scale;
            const first = state[0], last = state[state.length - 1];
            const front = sides.front.length,
              left = sides.left.length,
              right = sides.right.length,
              back = sides.back.length;
            
            /*console.log(state, first, last, {
                front: front,
                left: left,
                right: right,
                back: back,
            }, offset);*/
            
            let axisX, axisY, position;
            
            if (back && back >= front) {
                //console.log('position: back');
                
                if (left > right) {
                    position = 'frontLeft';
                    axisX = -firstAngle.x + person.imageSize / 2 * person.scale;
                    axisY = -firstAngle.y + person.imageSize / 2 * person.scale;
                    //console.log('position: back left', 'x: ' + axisX, 'y: ' + axisY, firstAngle);
                } /*else if (right > left) {
                    position = 'back';
                    axisX = first.x - offset;
                    axisY = first.y - offset;
                    console.log('position: back right', 'x: ' + axisX, 'y: ' + axisY);
                }*/
            } else if (front && right > left && right > 2) {
                position = 'frontRight';
                axisX = first.x + offset;
                axisY = first.y + offset;
                //console.log('position: frontRight', 'x: ' + axisX, 'y: ' + axisY);
            } else if (front && left > right && left > 1) {
                position = 'frontLeft';
                axisX = last.x + offset;
                axisY = last.y + offset;
                //console.log('position: frontLeft', 'x: ' + axisX, 'y: ' + axisY);
            } else {
                position = 'front';
                
                axisX = last.x + offset;
                axisY = last.y + offset;
                
                /*if (left === right) random = sofa.helpers.randomInteger(1, 2);
        
                if (right > left || random === 1) { // left side
                    axisX = first.x + offset;
                    axisY = first.y + offset;
                } else if (left > right || random === 2) { // right side
                    axisX = last.x + offset;
                    axisY = last.y + offset;
                }*/
                
                //console.log('position: front', 'x: ' + axisX, 'y: ' + axisY);
            }
            
            
            /*Return person position to draw*/
            /*К фиксированному значению добавляем коэффициент от масштабирования чтоб человек стоял на месте*/
            return {
                x: 180 + (180 - (180 * person.group.scaleX())),
                y: 300 + (300 - (300 * person.group.scaleY())),
                position: 'front',
            }
        }
    }
    
    /**
     * Random min, max integer
     *
     * @param {Number} min
     * @param {Number} max
     *
     * @returns {Number}
     */
    randomInteger(min, max) {
        return Math.round(min - 0.5 + Math.random() * (max - min + 1));
    }
    
    
    getAnglesInfo(state) {
        
        let frontRightCount = 0;
        let frontLeftCount = 0;
        
        let angleLeft = {
            exists: false,
            prepend: false
        };
        let angleRight = {
            exists: false,
            prepend: false
        };
        let angleBackRight = {
            exists: false,
            prepend: false
        };
        let angleBackLeft = {
            exists: false,
            prepend: false
        };
        let armrestPrepend = false;
        let armrestAppend = false;
        
        /*определяем наличие углов*/
        for (let i = 0; i < state.length; i++) {
            
            if (state[i]['highlight'] === 0 && state[i]['targetItem'] !== true) {
                if (state[i]['position'] === 'frontRight' && !state[i]['isChair'] === true) {
                    frontRightCount++;
                }
                
                if (state[i]['position'] === 'frontLeft' && !state[i]['isChair'] === true) {
                    frontLeftCount++;
                }
                
                if (state[i]['isArmrest'] && i !== 0 && state[i]['highlight'] === 0) {
                    if (state[i]['prepends'] || state[i]['pushToStart']) {
                        armrestPrepend = true;
                    } else {
                        armrestAppend = true;
                    }
                }
                
                if (state[i]['isAngle'] === true && (state[i]['position'] === 'front')) {
                    angleLeft = {
                        exists: true,
                        prepend: state[i]['prepends']
                    };
                }
                
                if (state[i]['isAngle'] === true && (state[i]['position'] === 'frontRight')) {
                    angleRight = {
                        exists: true,
                        prepend: state[i]['prepends']
                    };
                }
                
                if (state[i]['isAngle'] === true && (state[i]['position'] === 'frontLeft')) {
                    angleBackLeft = {
                        exists: true,
                        prepend: state[i]['prepends']
                    };
                }
                
                if (state[i]['isAngle'] === true && (state[i]['position'] === 'back')) {
                    angleBackRight = {
                        exists: true,
                        prepend: state[i]['prepends']
                    };
                }
            }
        }
        
        return {
            frontRightCount: frontRightCount,
            frontLeftCount: frontLeftCount,
            angleLeft: angleLeft,
            angleRight: angleRight,
            angleBackRight: angleBackRight,
            angleBackLeft: angleBackLeft,
            armrestPrepend: armrestPrepend,
            armrestAppend: armrestAppend
        }
    }
    
    clickOutOfElement($element, className = 'active', method = 0) {
        $(document).on('click', function (e) {
            if (!$element.is(e.target)
              && $element.has(e.target).length === 0) {
                
                if (method !== 0) {
                    $element.hide();
                } else {
                    $element.removeClass(className);
                }
            }
        })
    }
    
    /**
     * change renders material
     *
     * @param {Object} object - ConfiguratorCanvas object
     *
     */
    changeMaterial(object) {
        object.sofa.state.forEach(function (item, index) {
            let images = object.layer.find('.image-' + item.id);
            
            images.forEach(function (image, img_index) {
                image.image(object.sofa.sections[item.id]['image'][image.info.position]['img'])
            })
        });
        
        object.layer.draw();
        
        object.$loaderOptions.addClass('d-none');
    }
    
    /**
     * get edge modules positions
     *
     * @param {Object} object - ConfiguratorCanvas object
     *
     * @return edge modules positions and isAngle
     */
    getEdgeModulesPosition(object) {
        return {
            first: {
                position: object.sofa.edgeModules.first.item.position,
                isAngle: object.sofa.edgeModules.first.item.isAngle
            },
            last: {
                position: object.sofa.edgeModules.last.item.position,
                isAngle: object.sofa.edgeModules.last.item.isAngle
            }
        }
    }
    
    /**
     * TODO: change module adding-radius position in case of edge modules positions
     *
     * @param {Object} object - ConfiguratorCanvas object
     *
     * @return edge modules positions and isAngle
     */
    getAddModuleRadiusShift(object) {
        let edgeModulesPosition = this.getEdgeModulesPosition(object);
        let shiftFirst = {x: 0, y: 0}
        let shiftLast = {x: 0, y: 0}
        
        console.log('edgeModulesPosition', edgeModulesPosition);
        
        if (edgeModulesPosition.first.position === 'front') {
            if (edgeModulesPosition.first.isAngle) {
                shiftFirst = {x: -50, y: 50}
            } else {
                shiftFirst = {x: -50, y: 50}
            }
        }
        if (edgeModulesPosition.first.position === 'frontLeft') {
            if (edgeModulesPosition.first.isAngle) {
                shiftFirst = {x: 50, y: 50}
            } else {
                shiftFirst = {x: -50, y: 50}
            }
        }
        if (edgeModulesPosition.first.position === 'frontRight') {
            if (edgeModulesPosition.first.isAngle) {
                shiftFirst = {x: -50, y: 50}
            } else {
                shiftFirst = {x: -50, y: 50}
            }
        }
        if (edgeModulesPosition.first.position === 'back') {
            if (edgeModulesPosition.first.isAngle) {
                shiftFirst = {x: 50, y: -50}
            } else {
                shiftFirst = {x: 50, y: 50}
            }
        }
    }
    
    /**
     * Get edge modules indexes depends on chair count
     * Получить индекс крайних модулей в зависимости от количества кресел
     * @param {ConfiguratorSofa} object - ConfiguratorSofa object
     * @param {Boolean} draggingDistancedModule - current dragging item is distanced module?
     * @return {object} - обьект с индексами
     * */
    getEdgeModuleIndex(object, draggingDistancedModule = false) {
        let firstIndex = 0
        let lastIndex = object.state.length - 1
        
        if (!draggingDistancedModule) {
            object.state.forEach((item, index) => {
                if (item.isChair && item.highlight !== 1 && !item.targetItem) {
                    if (item.prepends) {
                        firstIndex++
                    } else {
                        lastIndex--
                    }
                }
            })
        }
        
        return {
            firstIndex: firstIndex,
            lastIndex: lastIndex
        }
    }
    
    /**
     * check nonexistent configurations
     *
     * @param {Object} object - ConfiguratorCanvas object
     * @param {Object} newItem - new section
     *
     * @return array of id`s of modules that cause nonexistent configurations
     * */
    checkNonExistentConfigurations(object, newItem) {
        
        let allowBuild = this.processNonExistentConfigurations(object, newItem);
        
        if (!allowBuild) {
            if (object.sofa.chair.exists) {
                // this.removeChair(object);
                allowBuild = this.processNonExistentConfigurations(object, newItem);
            }
        }
        
        return allowBuild;
    }
    
    
    /**
     * check nonexistent configurations
     *
     * @param {Object} object - ConfiguratorCanvas object
     * @param {Object} newItem - new section
     *
     * @return array of id`s of modules that cause nonexistent configurations
     * */
    processNonExistentConfigurations(object, newItem) {
        let helpers = this;
        let frontLeft = 0;
        let frontRight = 0;
        let front = 0;
        let back = 0;
        let allowBuild = true;
        let state = object.sofa.state.slice();
        let section = Object.assign({}, newItem);
        
        // console.log('/////////////////////////////////////////////////////////////////////////////////////////////');
        
        
        if (section !== false) {
            if (object.sofa.chair.exists) {
                
                if (object.sofa.chair.prepends) {
                    if (section.prepends || section.pushToStart) {
                        state.splice(1, 0, section);
                    } else {
                        state.push(section);
                    }
                } else {
                    if (section.prepends || section.pushToStart) {
                        state.unshift(section);
                    } else {
                        state.splice(state.length - 1, 0, section);
                    }
                }
            } else {
                if (section.prepends === true || section.pushToStart) {
                    state.unshift(section);
                } else {
                    state.push(section);
                }
            }
        }
        
        let angles = helpers.getAnglesInfo(state)
        /*
                console.log('angles', angles);
                console.log('state', state);
        */
        
        state.forEach((item, index) => {
            
            let sectionObject = object.sofa.sections[item.id];
            let sizeX = sectionObject['sizes']['x'];
            let sizeY = sectionObject['sizes']['y'];
            
            if (item.isAngle) {
                if (item.position === 'front') {
                    frontLeft += sizeY;
                    front += sizeX;
                } else if (item.position === 'frontLeft') {
                    frontLeft += sizeX;
                    back += sizeY;
                } else if (item.position === 'frontRight') {
                    front += sizeY;
                    frontRight += sizeX;
                } else if (item.position === 'back') {
                    frontRight += sizeY;
                    back += sizeX;
                }
            } else if (item.isChair || item.isPuff) {
                if (item.position === 'front') {
                    front += sizeX * 2;
                } else if (item.position === 'frontLeft') {
                    frontLeft += sizeX * 2;
                } else if (item.position === 'frontRight') {
                    frontRight += sizeX * 2;
                } else if (item.position === 'back') {
                    back += sizeX * 2;
                }
            } else {
                if (item.position === 'front') {
                    front += sizeX;
                } else if (item.position === 'frontLeft') {
                    frontLeft += sizeX;
                } else if (item.position === 'frontRight') {
                    frontRight += sizeX;
                } else if (item.position === 'back') {
                    back += sizeX;
                }
            }
        });
        
        /*
                console.log('frontLeft', frontLeft);
                console.log('frontRight', frontRight);
                console.log('front', front);
                console.log('back', back);
        */
        
        
        /*Если левая часть больше правой, а задняя часть больше передней, перекрещивается слева в углу*/
        if (frontLeft >= frontRight && front <= back) {
            
            // console.log('левая часть >= правой, а задняя часть >= передней');
            
            if (angles.angleBackRight.exists) {
                
                // console.log('Задний правый угол существует');
                
                if (!angles.angleBackRight.prepend) {
                    
                    // console.log('Задний правый угол prepend ', angles.angleBackRight.prepend);
                    
                    allowBuild = false;
                    
                }
                
            }
        }
        
        /*Если правая часть больше левой, а задняя часть больше передней, перекрещивается справа в углу*/
        if (frontLeft <= frontRight && front <= back) {
            
            // console.log('правая часть >= левой, а задняя часть >= передней');
            
            if (angles.angleBackLeft.exists) {
                
                // console.log('Задний левый угол существует');
                
                if (angles.angleBackLeft.prepend) {
                    
                    // console.log('Задний левый угол prepend ', angles.angleBackLeft.prepend);
                    
                    allowBuild = false;
                    
                }
            }
        }
        
        /*Если левая часть больше правой, а задняя часть больше передней, перекрещивается слева в углу*/
        if (frontLeft >= frontRight && front >= back) {
            
            // console.log('левая часть >= правой, а задняя часть <= передней');
            
            if (angles.angleBackLeft.exists && angles.angleBackRight.exists) {
                
                // console.log('angles.angleBackLeft.exists && angles.angleBackRight.exists');
                
                if (!angles.angleBackLeft.prepend && angles.angleBackRight.prepend) {
                    
                    // console.log('!angles.angleBackLeft.prepend && angles.angleBackRight.prepend');
                    
                    allowBuild = false;
                }
                
                if (!angles.angleBackLeft.prepend && !angles.angleBackRight.prepend) {
                    // console.log('!angles.angleBackLeft.prepend && !angles.angleBackRight.prepend');
                    
                    allowBuild = false;
                }
                
            }
        }
        
        /*Если правая часть больше левой, а задняя часть больше передней, перекрещивается справа в углу*/
        if (frontLeft <= frontRight && front >= back) {
            
            // console.log('правая часть >= левой, а задняя часть <= передней');
            
            if (angles.angleBackLeft.exists && angles.angleBackRight.exists) {
                
                // console.log('angles.angleBackLeft.exists && angles.angleBackRight.exists');
                
                if (angles.angleBackLeft.prepend && angles.angleBackRight.prepend) {
                    
                    // console.log('angles.angleBackLeft.prepend && angles.angleBackRight.prepend');
                    
                    allowBuild = false;
                }
            }
        }
        
        let siblingAngles = helpers.checkSiblingAngles(state);
        
        if (siblingAngles === 'triple') {
            allowBuild = false;
            console.log('not allowed build because of triple sibling angles');
        } else {
            siblingAngles.forEach((item, index) => {
                let first = item[0];
                
                if (first.position === "frontLeft" || first.position === 'frontRight') {
                    
                    // console.log('first.position === "frontLeft" || first.position === \'frontRight\'');
                    
                    let back = state.filter((item) => {
                        if (first.position === "frontLeft") {
                            return !item.isAngle && item.position === 'back' && item.prepends;
                        } else if (first.position === 'frontRight') {
                            return !item.isAngle && item.position === 'back' && !item.prepends;
                        } else {
                            return false;
                        }
                    });
                    
                    if (back.length > 0) {
                        console.log('not allowed build because of sibling angles');
                        allowBuild = false;
                    }
                } else if (first.position === 'back') {
                    let frontRight = state.filter((item) => {
                        if (first.prepends) {
                            return !item.isAngle && item.position === 'frontRight' && item.prepends;
                        } else {
                            return !item.isAngle && item.position === 'frontLeft' && !item.prepends;
                        }
                    });
                    
                    if (frontRight.length > 0) {
                        console.log('not allowed build because of sibling angles with first.position === \'back\'');
                        allowBuild = false;
                    }
                }
            })
        }
        
        // console.log('allowBuild', allowBuild);
        return allowBuild;
    }
    
    /**
     * Check that shapes has intersection
     *
     * @param r1 - first shape
     * @param r2 - second shape
     *
     * */
    haveIntersection(r1, r2) {
        return !(
          r2.x > r1.x + r1.width ||
          r2.x + r2.width < r1.x ||
          r2.y > r1.y + r1.height ||
          r2.y + r2.height < r1.y
        );
    }
    
    /**
     * Check that configuration has sibling angles and then return it
     *
     * @param {object} state
     * */
    checkSiblingAngles(state) {
        
        let siblings = [];
        
        state.forEach(function (item, index) {
            /*Check triple angles*/
            if (state.length > 3 &&
              (typeof state[index - 1] !== "undefined" && state[index - 1].isAngle)
              && item.isAngle
              && (typeof state[index + 1] !== "undefined" && state[index + 1].isAngle)) {
                console.log('state.length > 3 && \n' +
                  '                (typeof state[index-1] !== "undefined" && state[index-1].isAngle)\n' +
                  '                && item.isAngle\n' +
                  '                && (typeof state[index+1] !== "undefined" && state[index+1].isAngle)');
                siblings = 'triple';
            } else if (item.isAngle && (typeof state[index + 1] !== "undefined" && state[index + 1].isAngle) && siblings !== 'triple') {
                siblings.push([
                    item,
                    state[index + 1]
                ])
            }
        })
        
        return siblings;
    }
    
    /**
     * Remove Chair
     * @param {object} object - ConfiguratorCanvas object
     * @param {boolean} forEach - forEach or filter function
     * */
    
    removeChair(object, forEach = false) {
        
        console.log('object.sofa.state from removeChair', object.sofa.state);
        
        if (forEach) {
            object.sofa.state.forEach((item, index) => {
                if (item.isChair) {
                    if (item.prepends) {
                        object.sofa.state.splice(0, 1)
                    } else {
                        object.sofa.state.pop();
                    }
                }
            })
        } else {
            object.sofa.state = object.sofa.state.filter((item) => {
                return !item.isChair;
            })
        }
        
        object.sofa.chair.exists = false;
    }
    
    /**
     * Get translated phrases for current language in json format
     * @param {Array} phrases - array of phrases
     * @param {object} object - ConfiguratorCanvas object
     * */
    getTranslatedPhrases(phrases, object) {
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'phrases': phrases,
                'action': 'get_translated_phrase',
            },
            success: (response) => {
                // console.log('response phrases translated', response)
                object.configData.translatedPhrases = response;
            },
            error: (jqXHR, exception) => {
                this.jqXHRMessage(jqXHR, exception)
            }
        });
    }
    
    /**
     * Synchronize current sofa with its translations
     * @param {Number} sofaId - sofa id
     * @param {ConfiguratorCanvas} object - sofa id
     * */
    synchronizeCanvasTranslations(sofaId, object) {
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'sofaId': sofaId,
                'action': 'synchronize_canvas_translations',
            },
            beforeSend: () => {
                object.$loaderOptions.removeClass('d-none');
            },
            success: (response) => {
                console.log('synchronize_canvas_translations', response)
            },
            error: (jqXHR, exception) => {
                this.jqXHRMessage(jqXHR, exception)
            },
            complete: () => {
                object.$loaderOptions.addClass('d-none');
            }
        });
    }
    
    /**
     * Check device orientation
     * Проверить ориентацию устройства
     * @return {string} - landscape || portrait
     * */
    checkDeviceOrientation() {
        
        // ------------------------- version for iOS --------------------------
        let orientation;
        
        // Find matches
        let mql = window.matchMedia("(orientation: portrait)");
        
        // If there are matches, we're in portrait
        if (mql.matches) {
            orientation = 'portrait'
        } else {
            orientation = 'landscape'
        }
        
        return orientation;
    }
    
    /**
     * Функция, которая задает управляет сдвигами модулей по shiftX и shiftY.
     * @param {ConfiguratorSofa} object
     * */
    addShift(object) {
        
        /*перебираем каждый элемент в state*/
        object.state.forEach((_item, _index) => {
            _item.shiftedX = 0
            _item.shiftedY = 0
            
            /*Снова перебираем модули, чтоб понять на сколько по итогу его надо сместить*/
            object.state.forEach((item, index) => {
                
                /*определяем связь текущего модуля с его инфой из админки*/
                let sectionObject = object.sections[item.id]['image'][item.position]
                let queuePosition;
    
                if(item.prepends) {
                    queuePosition = 'prepend'
                }
                else {
                    queuePosition = 'append'
                }
                /*если смещение задано, нужно добавить его к модулю*/
                if (sectionObject[queuePosition]['shiftX'] !== 0 || sectionObject[queuePosition]['shiftY'] !== 0) {
                    
                    /*если элемент со сдвигом строится против часовой*/
                    if(item.prepends) {
                        /*
                        * если порядковый номер элемента со сдвигом больше порядкового номера текущего элемента.
                        * Для сдвига всех "перед"
                        * */
                        if (_index < index) {
                            _item.shiftedX += Number(sectionObject['prepend']['shiftX'])
                            _item.shiftedY += Number(sectionObject['prepend']['shiftY'])
                        }
                    }
                    /*если элемент со сдвигом строится по часовой*/
                    else {
                        /*
                        * если порядковый номер элемента со сдвигом меньше порядкового номера текущего элемента.
                        * Для сдвига всех "после"
                        * */
                        if (_index > index) {
                            _item.shiftedX += Number(sectionObject['append']['shiftX'])
                            _item.shiftedY += Number(sectionObject['append']['shiftY'])
                        }
                        /*Но если это левый верхний угол, так же стоит сдвигать "после"*/
                        else if (_index < index && item.position === 'front' && item.isAngle) {
                            _item.shiftedX += Number(sectionObject['append']['shiftX'])
                            _item.shiftedY += Number(sectionObject['append']['shiftY'])
                        }
                    }
                }
            })
        })
    }
    
    /**
     * Динамическое добавление shiftX и shiftY
     * @param {ConfiguratorSofa} object
     * @param {object} item - объект state, который мы хотим менять
     * @param val {object} - обьект, который содержит x и y значения для shiftX и shiftY
     * */
    addShiftDynamic(object, item, val) {
        
        let sectionObject = object.sections[item.id]['image'][item.position]
        let queuePosition
    
        if(item.prepends) {
            queuePosition = 'prepend'
        }
        else {
            queuePosition = 'append'
        }
        
        sectionObject[queuePosition]['shiftX'] = Number(val.x)
        sectionObject[queuePosition]['shiftY'] = Number(val.y)
        
        this.addShift(object)
    }
}

export default Helpers;
